import type { SVGProps } from "react";
export interface TornadoIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TornadoIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TornadoIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M21 2.875c.621 0 1.125.504 1.125 1.125 0 2.556-.5 4.395-1.348 5.848l-.019.032q-.344.581-.758 1.09c-.637.781-1.365 1.416-2.092 1.995-.582.463-1.095.84-1.635 1.265l-.554.446a12.3 12.3 0 0 0-2.194 2.427c-.828 1.213-1.488 2.7-1.482 4.326l-.015.233c-.072.531-.39.97-.799 1.22a1.61 1.61 0 0 1-1.546.083l-.227-.136c-4.61-3.272-4.136-7.956-2.965-10.327.668-1.353.504-1.805.385-2.026-.096-.178-.264-.374-.57-.66-.256-.24-.72-.639-1.101-1.02-.533-.532-1.418-1.308-2.022-1.983C2.56 6.114 1.875 5.16 1.875 4a1.122 1.122 0 0 1 2.174-.397q.07.045.215.113c.39.183 1.01.381 1.822.56 1.611.357 3.779.599 5.914.599s4.303-.242 5.913-.598c.813-.18 1.433-.378 1.823-.561a2 2 0 0 0 .214-.113c.16-.425.569-.728 1.05-.728m-1.283 3.248c-.405.128-.85.248-1.317.351-1.785.394-4.117.65-6.4.65-2.054 0-4.147-.21-5.846-.539.204.192.417.395.641.62.37.369.653.597 1.05.968.345.325.736.723 1.011 1.234.625 1.156.461 2.456-.347 4.091-.75 1.518-1.135 4.414 1.363 6.772.238-1.745.99-3.258 1.794-4.435a14.6 14.6 0 0 1 2.62-2.892c.743-.616 1.59-1.237 2.22-1.739q.166-.135.325-.268a35 35 0 0 1-3.83.189 1.125 1.125 0 0 1 0-2.25c2.463 0 4.311-.197 6.057-.577.29-.597.518-1.305.659-2.175"
      />
      <path
        fill={color}
        d="M20.376 13.064a1.125 1.125 0 1 1 1.248 1.872c-1.73 1.153-4.577 2.189-9.398 2.189-4.49 0-7.682-.899-9.504-1.972l-.346-.217-.092-.069a1.125 1.125 0 0 1 1.24-1.862l.1.059.253.158c1.357.794 4.101 1.652 8.349 1.652 4.498 0 6.88-.963 8.15-1.81M12 .875c2.283 0 4.615.258 6.4.652.884.195 1.687.435 2.294.72.299.141.609.32.861.551.24.221.57.625.57 1.202s-.33.981-.57 1.202c-.252.232-.562.41-.861.55-.607.286-1.41.527-2.294.722-1.785.394-4.117.65-6.4.65s-4.615-.256-6.4-.65c-.885-.196-1.687-.436-2.294-.721a3.4 3.4 0 0 1-.861-.55c-.21-.194-.49-.528-.555-.995L1.875 4l.015-.208c.066-.467.344-.8.555-.994a3.4 3.4 0 0 1 .861-.55c.607-.286 1.41-.526 2.294-.721C7.385 1.133 9.717.875 12 .875m0 2.25c-2.135 0-4.303.243-5.914.6q-.607.132-1.063.275.457.141 1.063.277c1.611.356 3.779.598 5.914.598s4.303-.242 5.913-.598q.607-.136 1.063-.277a14 14 0 0 0-1.063-.276c-1.61-.356-3.778-.599-5.913-.599"
      />
    </svg>
  );
}
